import React, { Component } from 'react';
import Scroll from 'react-scroll';

const animateScroll = Scroll.animateScroll;

class ScrollToNextButton extends Component {

  handleClick(e) {
    const currentSection = e.currentTarget.closest('section');

    // closest section, next sibling, top value
    if (currentSection.nextSibling) {
      animateScroll.scrollTo(e.currentTarget.closest('section').nextSibling.offsetTop)
    }
  }

  render() {
    return (
      <div className="next-nav-wrap">
        <div className="next-nav-button" style={{ fill: this.props.color || 'white'}} onClick={this.handleClick} aria-label="Next section" title="Next section">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M441.9 250.1l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L250 385.4V44c0-6.6-5.4-12-12-12h-28c-6.6 0-12 5.4-12 12v341.4L42.9 230.3c-4.7-4.7-12.3-4.7-17 0L6.1 250.1c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"/></svg>
        </div>
      </div>
    );
  }

}

export default ScrollToNextButton;



// WEBPACK FOOTER //
// ./src/components/ScrollToNextButton.js